module.exports = __webpack_public_path__ + "static/media/vibe-logo.db10a10d.svg";